import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {fetch} from 'whatwg-fetch';
import Slider from "react-slick";
import MediaQuery from 'react-responsive';
import Loading from "../Loading";
import Error from "../Error";
import DefaultImg from '../../images/default-img-220x226.png';
import * as moment from 'moment';
import 'moment/locale/es';
import loadScript from '../../lib/loadScript';
import styles from './styles.module.scss';

//-- Telemundo API
const PROGRAMGUIDE_API = 'https://www.telemundo.com/ajax/program_guide/feed/block';

/**
 * Component to display weekly Program Guide
 */
class ProgramGuide extends Component {

  /**
   * ProgramGuide Constructor
   *
   * @param props
   */
  constructor(props) {
    super(props);

    //-- Passing `this` to the callback
    this.next = this.next.bind(this);
    this.previous = this.previous.bind(this);
    this.goto = this.goto.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleVerticalClick = this.handleVerticalClick.bind(this);
    this.updateItem = this.updateItem.bind(this);
    this.fetchDayData = this.fetchDayData.bind(this);
    this.handleWeekDropdown = this.handleWeekDropdown.bind(this);
  }

  state = {
    selected: 0,
    week: [],
    isLoading: true,
    error: null,
    weekNumber: 0,
    weekisOpen: false,
    vertical:null,
  };

  /**
   * Next Slide
   */
  next() {
    this.slider.slickNext();
  }

  /**
   * Prev Slide
   */
  previous() {
    this.slider.slickPrev();
  }

  /**
   * Go To Slide
   *
   * @param index
   */
  goto(index) {
    this.slider.slickGoTo(index);
  }

  /**
   * After Component Load
   */
  componentDidMount() {
    //-- Mapping Week Object with data and Moment Object
    const week = [0, 1, 2, 3, 4, 5, 6].map((day, index) => ({
      index,
      date: moment().add(day, "d"),
      data: null
    }));

    //-- Setting Week State
    this.setState({
      week,
      isLoading: true
    });

    //-- Set if Vertical
    const searchQuery = window.location.search
    const urlParams = new URLSearchParams(searchQuery);
    let verticalState = (urlParams.get('vertical') === 'true') ? true : false

    this.setState({
      vertical: verticalState
    });
    //-- Fetching Programming Guide
    fetch(`${PROGRAMGUIDE_API}/${week[0].date.format("YYYY/MM/DD")}`, {
      method: 'GET', // or 'PUT'
    })
      .then(response => response.json())
      .then(data => data.map(program => ({...program, isOpen: false})))
      .then(data => this.updateItem(0, {data}))
      .catch(error => this.setState({error, isLoading: false}));

    //-- On Window Resize, reposition the Slider Arrows
    window.addEventListener("resize", this.positionSliderArrows.bind(this));
    }

  /**
   * On Component Unmount
   */
  componentWillUnmount() {

    //-- On Window Resize, reposition the Slider Arrows
    window.removeEventListener("resize", this.positionSliderArrows.bind(this));
  }

  /**
   * Updating States
   *
   * @param id
   * @param itemAttributes
   */
  updateItem(id, itemAttributes) {
    const index = this.state.week.findIndex(x => x.index === id);
    this.setState({
      isLoading: false,
      selected: index,
      week: [
        ...this.state.week.slice(0, index),
        Object.assign({}, this.state.week[index], itemAttributes),
        ...this.state.week.slice(index + 1)
      ]
    });

    if ( this.state.vertical !== true) {
        //-- Move SlideShow
        this.gotoSlide(index);
    }
    //-- Add Pym
    loadScript('https://nodeassets.nbcnews.com/cdnassets/pym/1.3.2/pym.min.js')
      .then(() => {
        if (window.pym) {
          // Pym adds iframe and establishes communication for controlling height.
          this.pymChild = new window.pym.Child();
          // Update Height
          this.pymChild.sendHeight()
        }
      });
  }

  /**
   * On Click Event
   *
   * @param index
   */
  handleClick(index) {

    if (this.state.week[index].data !== null) {

      //-- Select Day Programming
      this.setState({selected: index});

      //-- Move SlideShow
      this.gotoSlide(index);

    } else {

      //-- Fetch Programming Data
      this.fetchDayData(this.state.week[index]);
    }

    //-- Close Weekday Dropdown
    this.setState({
      weekNumber: index,
      weekisOpen: false,
    });
  }

  handleVerticalClick(index) {

    if (this.state.week[index].data !== null) {
  
      // //-- Select Day Programming
      this.setState({selected: index});
  
    } else {
  
      //-- Fetch Programming Data
      this.fetchDayData(this.state.week[index]);
    }
  }
  /**
   * Fetch Day Data on Click
   *
   * @param day
   */
  fetchDayData(day) {
    this.setState({isLoading: true});

    fetch(`${PROGRAMGUIDE_API}/${day.date.format("YYYY/MM/DD")}`, {
      method: 'GET',
    })
      .then(response => response.json())
      .then(data => this.updateItem(day.index, {data}))
      .catch(error => this.setState({error, isLoading: false}))
  }

  /**
   * Open Tablet/Mobile DropDown
   */
  handleWeekDropdown = () => {

    //-- Open and Close Dropdown with state
    this.setState(state => ({
      weekisOpen: !state.weekisOpen
    }));

  };

  /**
   * Get Current Slide Index
   *
   * @returns {*}
   */
  getSlideIndex = () => {

    //-- Now Time
    const now = moment().unix(); //1570243843

    //-- Find Index with findIndex
    const slideIndex = this.state.week[0].data.findIndex((item, index) => {

      //-- Get Current Timestamp
      const curTimestamp = this.state.week[0].data[index].time_GMT;

      //-- Get Next Timestamp
      const nextTimestamp = this.state.week[0].data[index + 1].time_GMT;

      //-- Return true if now is between current and next timestamps
      return (curTimestamp <= now && now <= nextTimestamp)
    });

    //-- Get SlideS to Show Total
    const slidesToShow = this.slider.innerSlider.props.slidesToShow;

    //-- Total Slide Show Count
    const slideShowCount = this.state.week[0].data.length;

    //-- Get Slide Bound
    const slideShowBound = slideShowCount - slidesToShow;

    //-- Return either the bound index or the actual index
    return (slideIndex > slideShowBound) ? slideShowBound : slideIndex;
  };

  /**
   * Move SlideShow to Currently playing Show
   *
   * @param index
   */
  gotoSlide = index => {
    //-- If Current Day got to slide Index else go to beginning of day
    (index === 0) ? this.goto(this.getSlideIndex()) : this.goto(0);
  };

  /**
   * Render WeekDays Rows
   *
   * @param week
   * @param selected
   */
  renderWeekDays = (week, selected) => {

    return (
      week.map(day => (
        <li key={day.index} onClick={() => this.handleClick(day.index)} className={selected === day.index ? styles.active : styles.inactive}>
          <span className={styles.MenuDay}>{day.date.format("dddd")}</span>
        </li>
      ))
    )
  };

  /**
   * Positioning Slider Arrows
   */
  positionSliderArrows = () => {

    //-- Slide Thumbnail Top Padding
    const imgTopPadding = 15;

    //-- Half of Arrows Height
    const arrowsHeight = 28 / 2;

    //-- Final Arrow Position: Half of Img height divided by 2 - half of the arrows height + top padding
    const arrowPos = (this.imgHeight.offsetHeight / 2 - arrowsHeight) + imgTopPadding;

    //-- Setting Arrow Top Position
    this.arrowPosRef.style.top = arrowPos + 'px';
  };

  /**
   * Render Program Guide Rows
   *
   * @param program
   * @param index
   * @returns {*}
   */
  renderVerticalProgram = (program, index) => {

    //-- Conditional Wrapping
    const ConditionalWrap = ({condition, wrap, children}) => condition ? wrap(children) : children;

    return (
      <div key={index} className={styles.ProgramGuideItem}>
        <div className={styles.Info}>
          <time className={styles.TimeFull}>{program.time_full}</time>
          <time className={styles.CentralTimeFull}>{program.central_time_full}</time>
        </div>
        <div className={styles.ImgWrapper}>
          <ConditionalWrap
            condition={program.url && program.url !== '#'}
            wrap={children => <a href={program.url} target={"_top"}>{children}</a>}>
            <img src={program.image_url ? program.image_url : DefaultImg} alt={program.name} ref={el => this.imgHeight = el} onLoad={this.positionSliderArrows}/>
          </ConditionalWrap>
        </div>
          <div className={styles.Title}>
            <a href={program.url} target={"_top"}>{program.name}</a>
          </div>
      </div>
    )
  };

  renderProgram = (program, index) => {

    //-- Conditional Wrapping
    const ConditionalWrap = ({condition, wrap, children}) => condition ? wrap(children) : children;

    return (
      <div key={index} className={styles.ProgramGuideItem}>
        <div className={styles.ImgWrapper}>
          <ConditionalWrap
            condition={program.url && program.url !== '#'}
            wrap={children => <a href={program.url} target={"_top"}>{children}</a>}>
            <img src={program.image_url ? program.image_url : DefaultImg} alt={program.name} ref={el => this.imgHeight = el} onLoad={this.positionSliderArrows}/>
          </ConditionalWrap>
        </div>
        <div className={styles.Info}>
          <time className={styles.TimeFull}>{program.time_full}</time>
          <time className={styles.CentralTimeFull}>{program.central_time_full}</time>
          <div className={styles.Title}>
            <a href={program.url} target={"_top"}>{program.name}</a>
          </div>
        </div>
      </div>
    )
  };

  returnHorizontalProgramGuideHtml() {
    const {title, fullGuideActive, fullGuideTitle, fullGuideLink, pgSlidesToShow, pgSlidesToScroll} = this.props;
    const {selected, week, isLoading, error, weekNumber, weekisOpen} = this.state;

    //-- Breakpoints
    const breakpoints = {
      'desktop': 900, // bigger than
      'tablet': 757, // smaller than
      'mobile': 375, // smaller than
    };
    //-- Slider Settings
    const SliderSettings = {
      className: styles.Slider,
      arrows: false,
      draggable: false,
      infinite: false,
      speed: 500,
      slidesToShow: pgSlidesToShow,
      slidesToScroll: pgSlidesToScroll,
      responsive: [
        {
          breakpoint: breakpoints.desktop,
          settings: {
            slidesToShow: 5,
          }
        },
        {
          breakpoint: breakpoints.tablet,
          settings: {
            slidesToShow: 3,
            draggable: true,
          }
        },
        {
          breakpoint: breakpoints.mobile,
          settings: {
            slidesToShow: 3,
            draggable: true,
          }
        }
      ]
    };

    if (error) {
      return <Error/>
    }

    return (
      <div className={styles.ProgramGuideContainer}>
        <section className={styles.ProgramGuideSection}>
          <h1 className={styles.ProgramGuideMainTitle}>{title}</h1>
          <div className={styles.ProgramGuide}>
            <div className={styles.ProgramGuideDates}>
              <div className={styles.ProgramGuideCurrentDay}>
                <h2 className={styles.ProgramGuideCurrentDayTitle}>{week.length !== 0 ? week[0].date.format("D [de] MMMM") : null}</h2>
              </div>
              <div className={styles.ProgramGuideMenu}>
                <MediaQuery minWidth={breakpoints.desktop}>
                  <ul className={[styles.ProgramGuideMenuList, styles.Desktop].join(' ')}>
                    {this.renderWeekDays(week, selected)}
                  </ul>
                </MediaQuery>
                <MediaQuery minWidth={breakpoints.mobile} maxWidth={breakpoints.desktop - 1}>
                  <div onClick={() => this.handleWeekDropdown()} className={styles.WeekDropdown}>
                    <div className={styles.WeekDropdownBtn}>
                      <span className={styles.WeekDropdownText}>{week[weekNumber] ? week[weekNumber].date.format("dddd") : null}</span>
                      <i className={['icon-caret-left', weekisOpen ? styles.Opened : styles.Closed].join(' ')}/>
                    </div>
                  </div>
                  <ul className={[styles.ProgramGuideMenuList, styles.Tablet, weekisOpen ? styles.Opened : styles.Closed].join(' ')}>
                    {this.renderWeekDays(week, selected)}
                  </ul>
                </MediaQuery>
                <MediaQuery maxWidth={breakpoints.mobile - 1}>
                  <div onClick={() => this.handleWeekDropdown()} className={styles.WeekDropdown}>
                    <div className={styles.WeekDropdownBtn}>
                      <span className={styles.WeekDropdownText}>{week[weekNumber] ? week[weekNumber].date.format("dddd") : null}</span>
                      <i className={['icon-caret-left', weekisOpen ? styles.Opened : styles.Closed].join(' ')}/>
                    </div>
                  </div>
                  <ul className={[styles.ProgramGuideMenuList, styles.Mobile, weekisOpen ? styles.Opened : styles.Closed].join(' ')}>
                    {this.renderWeekDays(week, selected)}
                  </ul>
                </MediaQuery>
              </div>
              {fullGuideActive ?
                <div className={styles.ProgramGuideComplete}>
                  <a href={fullGuideLink} className={styles.ProgramGuideCompleteTitle} target={"_top"}>{fullGuideTitle}</a>
                </div>
                : null}
            </div>
            <div className={styles.ProgramGuideItems}>
              {!isLoading ?
                <Slider ref={c => (this.slider = c)} {...SliderSettings}>
                  {week[selected].data.map((program, index) => this.renderProgram(program, index))}
                </Slider>
                : <Loading className={styles.sliderLoading} color={"red"}/>}
              <div className={styles.SliderArrows} ref={el => this.arrowPosRef = el}>
                <span onClick={this.previous} className={[styles.ArrowPrev, "icon-caret-left"].join(' ')}/>
                <span onClick={this.next} className={[styles.ArrowNext, "icon-caret-left"].join(' ')}/>
              </div>
            </div>
          </div>
        </section>
      </div>
    )
  }

  returnVerticalProgramGuideHtml() {
    const {title, pgSlidesToShow, pgSlidesToScroll} = this.props;
    const {selected, week, isLoading, error, weekNumber, weekisOpen} = this.state;

    //-- Breakpoints
    const breakpoints = {
      'desktop': 900, // bigger than
      'tablet': 757, // smaller than
      'mobile': 375, // smaller than
    };
    //-- Slider Settings
    const SliderSettings = {
      className: styles.Slider,
      arrows: false,
      draggable: false,
      infinite: false,
      speed: 500,
      slidesToShow: pgSlidesToShow,
      slidesToScroll: pgSlidesToScroll,
      responsive: [
        {
          breakpoint: breakpoints.desktop,
          settings: {
            slidesToShow: 5,
          }
        },
        {
          breakpoint: breakpoints.tablet,
          settings: {
            slidesToShow: 3,
            draggable: true,
          }
        },
        {
          breakpoint: breakpoints.mobile,
          settings: {
            slidesToShow: 3,
            draggable: true,
          }
        }
      ]
    };

    if (error) {
      return <Error/>
    }

    return (
      <div className={styles.VerticalProgramGuide}>
        <div className={styles.ProgramGuideContainer}>
          <section className={styles.ProgramGuideSection}>
            <h1 className={styles.ProgramGuideMainTitle}>{title}</h1>
            <div className={styles.ProgramGuide}>
              <div className={styles.ProgramGuideDates}>
                <div className={styles.ProgramGuideMenu}>
                  <ul className={[styles.ProgramGuideMenuList, styles.Desktop].join(' ')}>
                    {week.map(day => (
                      <li key={day.index} onClick={() => this.handleVerticalClick(day.index)} className={selected === day.index ? styles.active : styles.inactive}>
                        <MediaQuery minWidth={breakpoints.desktop}>
                          <span className={styles.MenuDay}>{day.date.format("dddd")}</span>
                        </MediaQuery>
                        <MediaQuery maxWidth={breakpoints.desktop}>
                          <span className={styles.MenuDay}>{day.date.format("ddd").replace(".","")}</span>
                        </MediaQuery>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
              <div className={styles.SliderArrows} ref={el => this.arrowPosRef = el}>
                <span onClick={() => this.handleVerticalClick((selected === 0 ? 6 : selected - 1))} className={[styles.ArrowPrev, "icon-caret-left"].join(' ')}/>
                <span onClick={() => this.handleVerticalClick(selected === 6 ? 0 : selected + 1)} className={[styles.ArrowNext, "icon-caret-left"].join(' ')}/>
                <div className={styles.ProgramGuideCurrentDay}>
                  <h2 className={styles.ProgramGuideCurrentDayTitle}>{week.length !== 0 ? week[selected].date.format("D [de] MMMM").toUpperCase() : null}</h2>
                </div>
              </div>
              <div className={styles.ProgramGuideItems}>
                {!isLoading ?
                    week[selected].data.map((program, index) => this.renderVerticalProgram(program, index))
                  : <Loading className={styles.sliderLoading} color={"red"}/>}
              </div>
            </div>
          </section>
        </div>
      </div>
    )
  }
  /**
   * Render Component ProgramGuide
   *
   * @returns {*}
   */
  render() {
    if (this.state.vertical === true) {
      return (
        this.returnVerticalProgramGuideHtml()
      )
    } else {
    return (
        this.returnHorizontalProgramGuideHtml()
      )
    }
  }
}

ProgramGuide.propTypes = {
  title: PropTypes.string,
  fullGuideActive: PropTypes.bool,
  fullGuideTitle: PropTypes.string,
  fullGuideLink: PropTypes.string,
  pgSlidesToShow: PropTypes.number,
  pgSlidesToScroll: PropTypes.number,
  authorization: PropTypes.string.isRequired,
  body: PropTypes.object,
};

ProgramGuide.defaultProps = {
  title: 'Guía de Programación',
  fullGuideActive: true,
  fullGuideTitle: 'Guía Completa',
  fullGuideLink: 'https://www.telemundo.com/guia-de-programacion',
  pgSlidesToShow: 7,
  pgSlidesToScroll: 1,
  authorization: 'CONFIG-TOKEN key="tve_web_telemundo", type="cpc"',
  body: {
    device: 'web',
    adobeMvpdId: '',
    serviceZip: '',
    encryptedZip: ''
  },
};

export default ProgramGuide;
